import { io } from "socket.io-client";
import { socketPath, wsApi } from "../urlConfig";

let socketInstance = null;

const getToken = () => {
    if (typeof window === "undefined") return "";
    return window.localStorage.getItem("token") || "";
};

export const getSocketUserId = () => {
    if (typeof window === "undefined") return null;

    try {
        const raw = window.localStorage.getItem("user");
        if (!raw) return null;

        const user = JSON.parse(raw);
        return user?._id || user?.id || null;
    } catch (_error) {
        return null;
    }
};

const getSocketConfigKey = () => `${wsApi}/admin|${socketPath}`;

const clearGlobalSocket = () => {
    if (typeof window === "undefined") return;

    delete window.socket;
    delete window.__ADMIN_SOCKET__;
    delete window.__ADMIN_SOCKET_CONFIG_KEY__;
};

export const getSocket = () => {
    const configKey = getSocketConfigKey();

    if (
        socketInstance &&
        typeof window !== "undefined" &&
        window.__ADMIN_SOCKET_CONFIG_KEY__ &&
        window.__ADMIN_SOCKET_CONFIG_KEY__ !== configKey
    ) {
        socketInstance.disconnect();
        socketInstance = null;
        clearGlobalSocket();
    }

    if (!socketInstance) {
        const token = getToken();

        socketInstance = io(`${wsApi}/admin`, {
            transports: ["websocket", "polling"],
            path: socketPath,
            reconnection: true,
            reconnectionAttempts: Infinity,
            reconnectionDelay: 800,
            reconnectionDelayMax: 5000,
            timeout: 15000,
            withCredentials: false,
            autoConnect: Boolean(token),
            auth: {
                token: token || undefined,
            },
        });

        socketInstance.on("connect", () => {
            const userId = getSocketUserId();

            if (userId) {
                socketInstance.emit("user:join", userId);
            }

            console.log("[admin-socket] connected", {
                id: socketInstance.id,
                url: `${wsApi}/admin`,
                path: socketPath,
                userId: userId || null,
            });
        });

        socketInstance.on("connect_error", (error) => {
            console.warn("[admin-socket] connect_error", error?.message || error);
        });

        socketInstance.on("disconnect", (reason) => {
            console.log("[admin-socket] disconnected", reason);
        });

        if (typeof window !== "undefined") {
            window.socket = socketInstance;
            window.__ADMIN_SOCKET__ = socketInstance;
            window.__ADMIN_SOCKET_CONFIG_KEY__ = configKey;
        }
    }

    return socketInstance;
};

export const refreshAdminSocketAuth = ({ forceReconnect = false } = {}) => {
    const current = getSocket();
    const nextToken = getToken();
    const previousToken = String(current.auth?.token || "");

    current.auth = {
        ...(current.auth || {}),
        token: nextToken || undefined,
    };

    if (!nextToken) {
        if (current.connected || current.active) {
            current.disconnect();
        }
        return current;
    }

    const tokenChanged = previousToken !== nextToken;

    if (current.connected && !tokenChanged && !forceReconnect) {
        const userId = getSocketUserId();
        if (userId) current.emit("user:join", userId);
        return current;
    }

    if (current.connected) {
        current.disconnect();
    }

    current.connect();

    return current;
};

export const joinSocketUser = () => {
    const current = getSocket();

    refreshAdminSocketAuth();

    const userId = getSocketUserId();

    if (current.connected && userId) {
        current.emit("user:join", userId);
    }

    return current;
};

export const reconnectSocketUser = () => {
    return refreshAdminSocketAuth({ forceReconnect: true });
};

export const disconnectAdminSocket = () => {
    if (!socketInstance) return;

    socketInstance.auth = {
        ...(socketInstance.auth || {}),
        token: undefined,
    };

    socketInstance.disconnect();
};

export const socket = getSocket();
